import { Formik } from 'formik';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import React, { RefObject } from 'react';
import { Flex } from 'reflexbox';
import { SelectButton } from 'primereact/selectbutton';
import { observer } from 'mobx-react';
import { Panel } from 'primereact/panel';
import BranchDropdown from '../attendance-driver/dropdown/BranchDropdown';

export interface IUndeliveredFilterContainerValue {
  startDate?: Date;
  branchName?: any;
}

@observer
export class UndeliveredKibanaFilterContainer extends React.Component<any, any> {
  dateRange: any = null;
  initialFormValues: IUndeliveredFilterContainerValue = {
    startDate: undefined,
    branchName:'',

  };

  refFormik: RefObject<Formik> = React.createRef();


  constructor(props, context) {
    super(props, context);
    this.state = {
      filterCollapsed: false
    };
  }

  get formValues() {
    if (this.refFormik.current) {
      return this.refFormik.current.state.values;
    }

    return {};
  }

  setFormValues(values) {
    if (this.refFormik.current) {
      const newFormValues = Object.assign({}, this.refFormik.current.state.values, values);
      this.refFormik.current!.setValues(newFormValues);
      this.initialFormValues = newFormValues;
      return newFormValues;
    }

    return null;
  }

  render() {
    return (
      <Panel header="Filter" toggleable={true} collapsed={this.state.filterCollapsed} onToggle={(e) => this.setState({ filterCollapsed: e.value })}>
        <Formik
          ref={this.refFormik}
          enableReinitialize
          initialValues={this.initialFormValues}
          onSubmit={() => { }}>
          {formikProps => (
            <Flex
              wrap
              w={1}>
              <Flex column>
                <div className="form-group">
                  <label className="col-md-4">Periode</label>
                  <div className="col-md-8">
                    <Flex column>
                      <Calendar
                        name="startDate"
                        readOnlyInput={true}
                        dateFormat="dd-mm-yy"
                        showWeek={true}
                        // maxDate={formikProps.values.endDate}
                        onBlur={formikProps.handleBlur}
                        onChange={formikProps.handleChange('startDate')}
                        value={formikProps.values.startDate}
                        showButtonBar={true}
                      />
                    </Flex>
                  </div>
                </div>
              </Flex>
              {/* <Flex style={{width: "350px"}} column>
                    <div className='form-group'>
                        <label className='col-md-4'>Nama Cabang</label>
                        <div className='col-md-8'>
                            <BranchDropdown
                              name='branchName'
                              onChange={formikProps.handleChange('branchName')}
                              placeholder={"Pilih Nama Cabang"}
                              filters={{
                                parameter: "name",
                                value: formikProps.values.branchName,
                              }}
                              value={formikProps.values.branchName}
                            />
                          
                        </div>
                      </div>
                    </Flex> */}
            </Flex>
          )}
        </Formik>
      </Panel>
    );
  }
}
